import { Global, css } from '@emotion/react'
import normalize from 'emotion-normalize'

import '../fonts/_font-face.css'
import { mq } from './mixins'

export const GlobalStyles = (): JSX.Element => {
  const globalStyles = css`
    ${normalize}
    :root {
      --sans-serif: system-ui, -apple-system, 'Segoe UI', Roboto,
        Helvetica, Arial, sans-serif, 'Apple Color Emoji',
        'Segoe UI Emoji';
      --slab-serif: Menlo, Consolas, Monaco, Liberation Mono,
        Lucida Console, monospace;
      --serif: Constantia, 'Lucida Bright', Lucidabright, 'Lucida Serif',
        Lucida, 'DejaVu Serif', 'Bitstream Vera Serif',
        'Liberation Serif', Georgia, serif;
      --ff-good-wide: 'ff-good-web-pro-wide', var(--sans-serif);
      --ff-good-extd: 'ff-good-web-pro-extended', var(--sans-serif);
      --ff-fairplex: 'fairplex-wide', 'Fairplex', var(--slab-serif);
      --ff-aktiv: '"aktiv-grotesk"', var(--sans-serif);

      /* Font Sizes */
      --fs-144: calc(4rem + 6.667vw);
      --fs-108: calc(4rem + 4.167vw);
      --fs-84: calc(3.875rem + 2.6vw);
      --fs-72: calc(3.3125rem + 2.2375vw);
      --fs-60: max(3rem, 2.75rem + 1.875vw);
      --fs-48: max(2.5rem, 2.25rem + 1.458vw);
      --fs-36: max(2.25rem, 2rem + 0.833vw);
      --fs-30: max(2rem, 1.5rem + 0.833vw);
      --fs-24: max(1.667rem, 1.5rem + 0.417vw);
      --fs-21: max(1.5rem, 1.25rem + 0.417vw);
      --fs-18: max(1.333rem, 1rem + 0.417vw);
      --fs-16: max(1.25rem, 0.8333rem + 0.417vw);
      --fs-15: 1.25rem;
      --fs-14: 1.167rem;
      --fs-13: 1.0888rem;
      --fs-12: 1rem;

      /* Padding/Gutters/Margins */
      --gtr-12: max(1.25vw, 0.5rem);
      --gtr-24: max(1.67vw, 0.75rem);
      --gtr-36: max(2.5vw, 1rem);
      --gtr-54: max(3.75vw, 2rem);
      --gtr-72: max(5vw, 3rem);
      --gtr-108: max(7.5vw, 4.5rem);
      --gtr-144: max(10vw, 6rem);

      --margin: var(--gtr-72);

      --grid-w: 100vw;

      --row-18: calc(0.5rem + 0.2vw + var(--gtr-12));
      --row-36: calc(1rem + 0.416vw + var(--gtr-12));
      --row-54: calc(1.5rem + 0.625vw + var(--gtr-24));
      --row-72: calc(2rem + 0.833vw + var(--gtr-36));
      --row-108: calc(3rem + 1.25vw + var(--gtr-54));
      --row-144: calc(4rem + 1.67vw + var(--gtr-72));

      ${mq().s} {
        --margin: calc(var(--gtr-36) + var(--gtr-12));
      }
      --col-w: calc(
        (100vw - 2 * var(--margin) - 11 * var(--gtr-36)) / 12
      );
    }

    html {
      font-size: 12px;
      ${mq('min').l} {
        font-size: calc(9px + 0.21vw);
      }
    }
    body {
      font-family: var(--ff-aktiv);
      font-size: var(--fs-16);
    }
    section {
      position: relative;
    }
    p {
      line-height: 150%;
    }
    button {
      appearance: none;
      border: none;
      background-color: transparent;
      color: inherit;
      padding: 0;
      cursor: pointer;
    }
    input,
    textarea,
    select {
      border-radius: 0;
      &:focus {
        outline: none;
      }
    }
    *:-webkit-autofill {
      &,
      &:hover,
      &:focus,
      &:active {
        transition: all 0s 99999s;
        border-radius: 0;
      }
    }
    .gatsby-image-wrapper-constrained {
      width: 100%;
      > div {
        max-width: 100% !important;
      }
    }
  `

  return <Global styles={globalStyles} />
}
